<template>
  <div>
    <div class="management_top_box">
      <h4>{{ $t("management.faqManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl">
        <tbody>
          <tr>
            <th>{{ $t("management.question") }}</th>
            <td>
              <input
                type="text"
                name="title"
                v-model="faq.title"
                class="form-control"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.answer") }}</th>
            <td colspan="2">
              <textarea
                v-model="faq.content"
                name="content"
                rows="10"
                class="form-control"
                v-validate="'required'"
              ></textarea>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/faq"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button type="button" @click="saveFaq" class="btn btn-primary btn-lg m-1">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="deleteFaq"
          v-if="this.$route.params.boardId != null"
          class="btn btn-secondary btn-lg m-1"
        >
          {{ $t("common.delete") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getFaq, saveFaq, editFaq, deleteFaq } from "@/api/faq";

export default {
  data() {
    return {
      faq: {},
      boardId: "",
      flag: "I",
      confirmYN: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getFaq(this.$route.params.boardId);
        this.faq = data.faq;
        if (this.faq != null) {
          this.flag = "U";
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveFaq() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        if (this.flag == "U") {
          const { data } = await editFaq(this.faq);
          if (data.message != null) {
            alert(this.$t("alert.plzCheckAllValues"));
          }
          if (data.status) {
            this.$router.push({ name: "mgmtFaq" });
          }
        } else if (this.flag == "I") {
          const { data } = await saveFaq(this.faq);
          if (data.message != null) {
            alert(this.$t("alert.plzCheckAllValues"));
          }
          if (data.status) {
            this.$router.push({ name: "mgmtFaq" });
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteFaq() {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteFaq(this.faq);
          if (data.status) {
            this.$router.push({ name: "mgmtFaq" });
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
  mounted() {
    if (this.$route.params.boardId != null) {
      this.fetchData();
    }
  },
};
</script>

<style></style>
